import { motion } from "framer-motion";
import { TESTIMONIALS } from "../data/site";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-40">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8">
        <div className="flex items-center gap-4 mb-16 md:mb-24">
          <span className="font-heading text-5xl md:text-6xl text-accent">5.0</span>
          <div>
            <div className="text-accent tracking-[0.3em] text-lg">★★★★★</div>
            <p className="overline mt-1">Rated by our customers</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`testimonial-${i}`}
              className="border-t border-border pt-8"
            >
              <blockquote className="font-heading font-light text-2xl md:text-4xl leading-[1.25] tracking-tight text-foreground/90">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm">
                <span className="font-medium">{t.author}</span>
                <span className="text-foreground/50"> — {t.role}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
